import { fromJS } from 'immutable';

export function requestedReducer(state) {
  let newState = fromJS(state);
  newState = newState.merge({
    requested: true,
    succeeded: false,
    failed: false
  });
  return newState.toJS();
}

export function succeededReducer(state) {
  let newState = fromJS(state);
  newState = newState.merge({
    requested: false,
    succeeded: true,
    failed: false
  });
  return newState.toJS();
}

export function failedReducer(state) {
  let newState = fromJS(state);
  newState = newState.merge({
    requested: false,
    succeeded: false,
    failed: true
  });
  return newState.toJS();
}



// WEBPACK FOOTER //
// ./src/reducers/request/index.js